import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { Box, Link } from '@mui/material';
export const LinkItem = ({
  text,
  url,
  index
}: {
  text: string;
  url: string;
  index: number;
}) => {
  const fireLinkClickedPageAction = usePageAction({
    actionInput: `${index}`,
    actionName: 'navigate_to_roundups',
    actionSection: 'navigate_to_roundups',
    targetPageURL: url,
    actionType: 'select'
  });
  return <Box sx={{
    display: 'flex'
  }}>
      <Link href={url} onClick={() => fireLinkClickedPageAction()} sx={theme => ({
      [theme.breakpoints.down('sm')]: {
        boxShadow: 'none',
        padding: 1,
        textAlign: 'left',
        display: 'list-item'
      },
      boxShadow: '0px 4px 8px 0px rgba(100, 102, 106, 0.10), 0px 1px 4px 0px rgba(100, 102, 106, 0.36)',
      padding: 4,
      display: 'flex',
      flexDirection: 'row',
      textAlign: 'center',
      alignItems: 'center'
    })}>
        {text}
      </Link>
    </Box>;
};